module.exports = __webpack_public_path__ + "static/assets/7f153e165ee21eaa9b45715d93801a34.png";